var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from './model';
var Part = /** @class */ (function (_super) {
    __extends(Part, _super);
    function Part() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Part.prototype.getOriginalInnerWidth = function () {
        return this.inner_x2 - this.inner_x1;
    };
    Part.prototype.getOriginalInnerHeight = function () {
        return this.inner_y2 - this.inner_y1;
    };
    Part.prototype.getInnerWidth = function (orientation) {
        if (orientation !== this.getOrientation()) {
            return this.getOriginalInnerHeight();
        }
        return this.getOriginalInnerWidth();
    };
    Part.prototype.getInnerHeight = function (orientation) {
        if (orientation !== this.getOrientation()) {
            return this.getOriginalInnerWidth();
        }
        return this.getOriginalInnerHeight();
    };
    Part.prototype.getInnerSize = function (orientation, maxWidth, maxHeight) {
        var outerSize = this.getOuterSize(orientation, maxWidth, maxHeight);
        var borderSizes = this.getBorderSizes(orientation, maxWidth, maxHeight);
        var width = outerSize.width - borderSizes.left - borderSizes.right;
        var height = outerSize.height - borderSizes.top - borderSizes.bottom;
        if (orientation !== this.getOrientation()) {
            return {
                width: height,
                height: width,
            };
        }
        return {
            width: width,
            height: height,
        };
    };
    Part.prototype.getOuterSize = function (orientation, maxWidth, maxHeight) {
        var ratio = this.getSizeRatio(orientation, maxWidth, maxHeight);
        var width = this.width * ratio;
        var height = this.height * ratio;
        if (orientation !== this.getOrientation()) {
            return {
                width: Math.ceil(height),
                height: Math.ceil(width),
            };
        }
        return {
            width: Math.ceil(width),
            height: Math.ceil(height),
        };
    };
    Part.prototype.getBorderSizes = function (orientation, maxWidth, maxHeight) {
        var ratio = this.getSizeRatio(orientation, maxWidth, maxHeight);
        var top = Math.ceil(this.inner_y1 * ratio);
        var left = Math.ceil(this.inner_x1 * ratio);
        var right = Math.ceil((this.width - this.inner_x2) * ratio);
        var bottom = Math.ceil((this.height - this.inner_y2) * ratio);
        if (orientation !== this.getOrientation()) {
            return {
                top: left,
                bottom: right,
                left: top,
                right: bottom,
            };
        }
        return {
            top: top,
            right: right,
            bottom: bottom,
            left: left,
        };
    };
    Part.prototype.getSizeRatio = function (orientation, maxWidth, maxHeight) {
        var ratio = maxWidth / this.getWidth(orientation);
        if (this.getHeight(orientation) * ratio > maxHeight) {
            ratio = maxHeight / this.getHeight(orientation);
        }
        return ratio;
    };
    Part.prototype.getOriginalInnerSizes = function (orientation) {
        return {
            width: this.getInnerWidth(orientation),
            height: this.getInnerHeight(orientation),
        };
    };
    Part.prototype.getWidth = function (orientation) {
        var productOrientation = this.getOrientation();
        if (orientation === productOrientation) {
            return this.width;
        }
        if ('square' === productOrientation) {
            return this.width;
        }
        return this.height;
    };
    Part.prototype.getHeight = function (orientation) {
        var productOrientation = this.getOrientation();
        if (orientation === productOrientation) {
            return this.height;
        }
        if ('square' === productOrientation) {
            return this.height;
        }
        return this.width;
    };
    Part.prototype.getOrientation = function () {
        var width = this.inner_x2 - this.inner_x1;
        var height = this.inner_y2 - this.inner_y1;
        if (width === height) {
            return 'square';
        }
        if (width > height) {
            return 'landscape';
        }
        return 'portrait';
    };
    return Part;
}(Model));
export { Part };
